import { useTranslation } from 'react-i18next'
import type { Contribution } from '@services/contribution/contribution'

export function ContributionListHeader() {
  const { t } = useTranslation()
  const columnStyling = `py-2 px-1 text-sm font-semibold text-gray-700 sm:pl-0`
  return (
    <tr>
      <th scope='col' className={`${columnStyling} text-left`}>
        {t('content.components.current_contributions.name_column_title')}
      </th>
      <th scope='col' className={`${columnStyling} text-left`}>
        {t('content.components.current_contributions.amount_column_title')}
      </th>
    </tr>
  )
}

export interface ContributionListItemProps {
  contribution: Contribution
}

export function ContributionListItem({ contribution }: ContributionListItemProps) {
  const rowStyling = 'whitespace-nowrap py-3 text-sm text-gray-500'

  // Remove .00 from amounts, but keep other decimal values
  const formatAmount = (amount: string): string => {
    return `$${Number.parseFloat(amount).toFixed(2).replace(/\.00$/, '')}`
  }

  return (
    <tr key={contribution.id}>
      <td className={`${rowStyling} text-left`}>{contribution.name}</td>
      <td className={`${rowStyling} text-left`}>{formatAmount(contribution.amount)}</td>
    </tr>
  )
}
